import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { Base64 } from 'js-base64';

@Injectable({
  providedIn: 'root'
})
export class CompaniaService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/catalogos/Compania';
  }

  obtenerCompania(){
    return this.httpClient.get(this.endpoint + '/ObtenerCompania');
  }
  insertarCompania(CompaniaRQ: any){
    return this.httpClient.post(this.endpoint + '/InsertarCompania', CompaniaRQ );
    //Como mandar un json en el body es con el CompaniaRQ
  }
  borrarCompania(CompaniaRQ: any){
    return this.httpClient.post(this.endpoint + '/BorrarCompania', CompaniaRQ );
  }
  modificarCompania(CompaniaRQ: any){
    return this.httpClient.post(this.endpoint + '/ModificarCompania', CompaniaRQ );
  }

}
